import { Fragment } from "react";
import { Container } from "@/components/container";
import {
  Toolbar,
  ToolbarActions,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from "@/partials/toolbar";
import { useLayout } from "@/providers";
import { usePermissions } from "@/hooks/usePermissions";
import { useNavigate } from "react-router-dom";
import { TestimonialsListing } from "./TestimonialsListing";

const TestimonialsManagement = () => {
  const { currentLayout } = useLayout();
  const { hasPermission } = usePermissions();
  const navigate = useNavigate();

  const handleCreateNavigate = () => navigate("/testimonial/create");

  return (
    <Fragment>
      {currentLayout?.name === "demo1-layout" && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle text="Testimonials" />
              <ToolbarDescription>
                You can manage testimonials shown on the public site here.
              </ToolbarDescription>
            </ToolbarHeading>
            <ToolbarActions>
              {hasPermission("cms_management_update") && (
                <button
                  type="button"
                  className="btn btn-sm btn-light"
                  onClick={handleCreateNavigate}
                  aria-label="Add new testimonial"
                >
                  Add New Testimonial
                </button>
              )}
            </ToolbarActions>
          </Toolbar>
        </Container>
      )}
      <Container>
        <TestimonialsListing />
      </Container>
    </Fragment>
  );
};

export { TestimonialsManagement };
